import { Injectable, EventEmitter } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class RouteService {


  is_display_route_register_component = false;
  RouteUpdate = new EventEmitter<ZONE>();

  downloadRoute = new EventEmitter<boolean>();

  private _route_data: ROUTE = null;

  constructor() { }

  set set_route_data(route) {
    this._route_data = route;
  }

  get get_route_data() {
    return this._route_data;
  }
}
export interface ROUTE {
  id: number;
  name: string;
}

